// components/atoms/Avatar.tsx
import React from 'react';
import fallbackAvatar from '../../../../assets/svgs/vocal_centric_standalone.svg'; // Ensure you have a fallback avatar image

interface AvatarProps {
    src?: string;
    alt?: string;
    size?: number; // optional size prop, defaults to 40
    className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, alt = 'User Avatar', size = 40, className = '' }) => {
    const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = fallbackAvatar;
    };

    return (
        <img
            src={src || fallbackAvatar}
            alt={alt}
            onError={handleError}
            width={size}
            height={size}
            className={`rounded-full object-cover ${className}`}
            style={{ width: size, height: size }}
        />
    );
};

export default Avatar;